import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const getAllBlogs = (page = 1, limit = 10, category = null) => {
  return Api(
    `${END_POINTS.getAllBlogs}?page=${page}&limit=${limit}${
      category ? `&category=${category}` : ""
    }`,
    null,
    REQUEST_TYPE.GET
  );
};

const getBlogDetail = (slug) => {
  return Api(`${END_POINTS.getBlogDetail}/${slug}`, null, REQUEST_TYPE.GET);
};

export { getAllBlogs, getBlogDetail };
